import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typography from '../../components/common/Typography';
import ai_banner from '../../asset/img/main_aibanner_img.svg';

const AiBanner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('main');
  return (
    <div className="aiBanner" onClick={() => navigate('/chat')}>
      <div className="aiBannerImg">
        <img src={ai_banner} alt={`${t('aiBannerTitle')} ${t('aiBannerDescription')}`} />
      </div>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="body1Bold" color="GrayScale-0">
          {t('aiBannerTitle')}
        </Typography>
        <Typography variant="body2Medium" color="GrayScale-0">
          {t('aiBannerDescription')}
        </Typography>
      </div>
    </div>
  );
};

export default AiBanner;
